<template>
    <header class="l-header">

        <router-link to="/fr" :title="siteName" class="l-header__logo-icon">
            <Icon icon="logo-icon" />
            <State />
        </router-link>

        <router-link to="/fr" :title="siteName" class="l-header__logo-text">
            <Icon icon="logo-text" />
        </router-link>

        <Btn
            tag="span"
            class="c-btn--filled-light | l-header__opening"
        >
            <State :displayLabel="true" />
        </Btn>

        <Btn
            v-if="restaurant && restaurant.booking.url"
            tag="a"
            :label="restaurant.booking.label"
            :title="`${restaurant.booking.label} avec ${restaurant.booking.name}`"
            :href="restaurant.booking.url"
            target="_blank"
            rel="noopener"
            class="c-btn--filled-light | l-header__book"
        />

        <Btn
            tag="a"
            href="/fr/commande-en-ligne/#/?service=takeout"
            label="Commander en ligne"
            title="Commander en ligne"
            class="c-btn--filled | l-header__order"
        >
            Commander en ligne
        </Btn>

        <button
            class="l-header__burger"
            aria-label="Ouvrir / Fermer le menu"
            @click="$emit('toggleNav')"
        ></button>
    </header>
</template>

<script>/* eslint-disable */

    import State from 'components/State'
    import Icon from 'components/Icon'
    import Btn from 'components/Btn'

    export default {
        name: 'AppHeader',
        components: {
            State,
            Icon,
            Btn
        },
        props: {
            restaurant: {
                type: Object
            }
        },
        computed: {

            site()  {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site

            },
            siteName() {

                if ( !this.site )
                    return

                return this.site.settings.site_name

            }
        }
    }

</script>

<style scoped>
</style>
